/* ShopYourHandle - global storefront JS: header platform-swap, AJAX cart, count badge,
   add-to-cart toast. Cart uses Shopify's native /cart AJAX API. */
(function () {
  'use strict';

  /* ---- Header platform "slot machine" (components/platform-swap.tsx) ------ */
  function initSwap() {
    var swap = document.querySelector('[data-ni-swap]');
    if (!swap) return;
    var track = swap.querySelector('.ni-swap__track');
    var items = track ? track.children.length : 0;
    if (!track || items < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    var step = swap.clientHeight; // one row
    setInterval(function () {
      i = (i + 1) % items;
      track.style.transform = 'translateY(' + -i * step + 'px)';
    }, 1900);
  }

  /* ---- Cart count -------------------------------------------------------- */
  function paintCount(n) {
    document.querySelectorAll('[data-ni-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () {});
  }

  /* ---- Cart drawer (slides in on add, shows what was added) -------------- */
  // Cents to the store's money format (€1.234,56), matching what the checkout
  // charges. Rounding to whole euros used to under-state every .99 price and, in
  // the crypto modal, told the buyer to send the wrong amount.
  function money(cents) {
    return fmt(Number(cents) / 100);
  }
  function fmt(v) {
    var parts = v.toFixed(2).split('.');
    return '\u20AC' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }
  var drawer = null, drawerHideTimer = null;
  function openDrawer(justId) {
    drawer = drawer || document.querySelector('[data-ni-drawer]');
    if (!drawer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var body = drawer.querySelector('[data-drawer-body]');
      if (!cart.items.length) body.innerHTML = '<p class="ni-drawer__empty">Your cart is empty.</p>';
      else body.innerHTML = cart.items.map(function (it) {
        var isNew = String(it.variant_id) === String(justId);
        return '<a class="ni-drawer__line' + (isNew ? ' is-new' : '') + '" href="' + it.url + '">' +
          '<span class="ni-drawer__linename">' + it.product_title + (isNew ? '<span class="ni-drawer__new">Added</span>' : '') + '</span>' +
          '<span class="ni-drawer__lineprice">' + money(it.final_line_price) + '</span></a>';
      }).join('');
      drawer.querySelector('[data-drawer-subtotal]').textContent = money(cart.total_price);
      window.__niCartTotal = cart.total_price; // used by the crypto modal (drawer "Pay with crypto")
      clearTimeout(drawerHideTimer);
      drawer.hidden = false;
      setTimeout(function () { drawer.classList.add('is-open'); }, 10);
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawerHideTimer = setTimeout(function () { drawer.hidden = true; }, 300);
  }

  /* ---- Add to cart (delegated) ------------------------------------------ */
  var busy = false;
  function addToCart(variantId, name, btn) {
    if (busy || !variantId) return;
    busy = true;
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCount();
        openDrawer(variantId);
        if (btn) { btn.classList.add('is-added'); btn.classList.remove('is-loading'); markAdded(variantId); }
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); })
      .finally(function () { busy = false; });
  }
  function markAdded(variantId) {
    document.querySelectorAll('[data-ni-add][data-variant="' + variantId + '"]').forEach(function (b) {
      b.classList.add('is-added');
      var l = b.querySelector('[data-ni-add-label]');
      if (l) l.textContent = b.getAttribute('data-added-label') || 'In cart ✓';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ni-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-added')) return;
    addToCart(btn.getAttribute('data-variant'), btn.getAttribute('data-name'), btn);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    // opening the crypto modal from the drawer: tuck the drawer away behind it
    else if (e.target.closest('[data-ni-crypto-open]') && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  window.NI = { refreshCount: refreshCount, addToCart: addToCart, openDrawer: openDrawer };
  document.addEventListener('DOMContentLoaded', function () { initSwap(); refreshCount(); });
})();
